// extracted by mini-css-extract-plugin
module.exports = {"container":"classes_container__dqvMW","shimmer":"classes_shimmer__q0Qua","placeholderShimmer":"classes_placeholderShimmer___JXEe","hidden":"classes_hidden__6CO1B"};